import R from 'ramda'

// Mapping form actions to widget actions

import {
  isGoogleSheetAppendFormAction,
  convertGoogleSheetAppendFormActionToWidgetAction
} from '../common/form-to-widget/google-sheet-append'

import {
  isFacebookCommentFormAction,
  convertFacebookCommentFormActionToWidgetAction
} from './form-to-widget/facebook-comment'

import {
  isFacebookDmFormAction,
  convertFacebookDmFormActionToWidgetAction
} from './form-to-widget/facebook-dm'

import {
  isFacebookOneTimeConsentFormAction,
  convertFacebookConsentActionToWidgetAction
} from './form-to-widget/facebook-onetime-consent'

import {
  isFacebookRecurringConsentAction,
  convertFacebookRecurringConsentActionToWidgetAction
} from './form-to-widget/facebook-recurring-consent'

import {
  isFacebookOneTimeOptInAction,
  convertFacebookOneTimeOptInActionToWidgetAction
} from './form-to-widget/facebook-onetime-optin'

import {
  isFacebookRecurringOptInFormAction,
  convertFacebookRecurringOptInActionToWidgetAction
} from './form-to-widget/facebook-recurring-optin'

import {
  isFacebookOneTimeOptOutAction,
  convertFacebookOneTimeOptOutActionToWidgetAction
} from './form-to-widget/facebook-onetime-optout'

import {
  isSendFacebookBlastFormAction,
  convertSendBlastFormActionToWidgetAction
} from './form-to-widget/send_facebook_blast'

import {
  isFacebookRecurringOptOutAction,
  convertFacebookRecurringOptOutActionToWidgetAction
} from './form-to-widget/facebook-recurring-optout'

// Mapping form widget actions to form actions

import {
  isGoogleSheetAppendWidgetAction,
  convertGoogleSheetAppendWidgetActionToFormAction
} from '../common/widget-to-form/google-sheet-append'

import {
  isFacebookCommentWidgetAction,
  convertFacebookCommentWidgetActionToFormAction
} from './widget-to-form/facebook-comment'

import {
  isFacebookDmWidgetAction,
  convertFacebookDmWidgetActionToFormAction
} from './widget-to-form/facebook-dm'

import {
  isOneTimeConsentAction,
  convertFacebookConsentWidgetActionToFormAction
} from './widget-to-form/facebook-onetime-consent'

import {
  isRecurringConsentAction,
  convertFacebookRecurringConsentWidgetActionToFormAction
} from './widget-to-form/facebook-recurring-consent'

import {
  isFacebookOneTimeWidgetOptInAction,
  convertFacebookOptInToFormAction
} from './widget-to-form/facebook-onetime-optin'

import {
  isFacebookRecurringWidgetOptInAction,
  convertFacebookRecurringOptInToFormAction
} from './widget-to-form/facebook-recurring-optin'

import {
  isFacebookOneTimeWidgetOptOutAction,
  convertFacebookOptOutToFormAction
} from './widget-to-form/facebook-onetime-optout'

import {
  isSendFacebookBlastWidgetAction,
  convertSendBlastWidgetActionToFormAction
} from './widget-to-form/send_facebook_blast'

import {
  isFacebookRecurringWidgetOptOutAction,
  convertFacebookRecurringOptOutToFormAction
} from './widget-to-form/facebook-recurring-optout'

const mapFacebookFormActionsToWidgetActions = R.map(
  R.cond([
    [
      isGoogleSheetAppendFormAction,
      convertGoogleSheetAppendFormActionToWidgetAction
    ],
    [
      isFacebookCommentFormAction,
      convertFacebookCommentFormActionToWidgetAction
    ],
    [isFacebookDmFormAction, convertFacebookDmFormActionToWidgetAction],
    [
      isFacebookOneTimeConsentFormAction,
      convertFacebookConsentActionToWidgetAction
    ],
    [
      isFacebookRecurringConsentAction,
      convertFacebookRecurringConsentActionToWidgetAction
    ],
    [
      isFacebookOneTimeOptInAction,
      convertFacebookOneTimeOptInActionToWidgetAction
    ],
    [
      isFacebookRecurringOptInFormAction,
      convertFacebookRecurringOptInActionToWidgetAction
    ],
    [
      isFacebookOneTimeOptOutAction,
      convertFacebookOneTimeOptOutActionToWidgetAction
    ],
    [
      isFacebookRecurringOptOutAction,
      convertFacebookRecurringOptOutActionToWidgetAction
    ],
    [isSendFacebookBlastFormAction, convertSendBlastFormActionToWidgetAction],
    [R.T, R.identity]
  ])
)

const mapFacebookWidgetActionsToFormActions = R.map(
  R.cond([
    [
      isGoogleSheetAppendWidgetAction,
      convertGoogleSheetAppendWidgetActionToFormAction
    ],
    [
      isFacebookCommentWidgetAction,
      convertFacebookCommentWidgetActionToFormAction
    ],
    [isOneTimeConsentAction, convertFacebookConsentWidgetActionToFormAction],
    [
      isRecurringConsentAction,
      convertFacebookRecurringConsentWidgetActionToFormAction
    ],
    [isFacebookDmWidgetAction, convertFacebookDmWidgetActionToFormAction],
    [isFacebookOneTimeWidgetOptInAction, convertFacebookOptInToFormAction],
    [
      isFacebookRecurringWidgetOptInAction,
      convertFacebookRecurringOptInToFormAction
    ],
    [isFacebookOneTimeWidgetOptOutAction, convertFacebookOptOutToFormAction],
    [isSendFacebookBlastWidgetAction, convertSendBlastWidgetActionToFormAction],
    [
      isFacebookRecurringWidgetOptOutAction,
      convertFacebookRecurringOptOutToFormAction
    ],
    [R.T, R.identity]
  ])
)

export {
  mapFacebookFormActionsToWidgetActions,
  mapFacebookWidgetActionsToFormActions
}



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/actions/facebook/index.js